<template>
<div class="leftside-menu">
    <router-link to="/kosiwon/list" class="logo logo-light">
        <span class="logo-lg">
            <img src="assets/images/logo.png" alt="logo">
        </span>
        <span class="logo-sm">
            <img src="assets/images/logo-sm.png" alt="small logo">
        </span>
    </router-link>

    <!-- Brand Logo Dark -->
    <router-link to="/kosiwon/list" class="logo logo-dark">
        <span class="logo-lg">
            <img src="https://s3.ap-northeast-2.amazonaws.com/kosirock.kosiwons.image/temp/1062752c25bada2fd07331e242844e0ec6ccd86759b1ec1352ae23af67e4973c.png" alt="dark logo">
        </span>
        <span class="logo-sm">
            <img src="assets/images/logo-dark-sm.png" alt="small logo">
        </span>
    </router-link>

    <!-- Sidebar Hover Menu Toggle Button -->
    <div class="button-sm-hover" data-bs-toggle="tooltip" data-bs-placement="right" title="Show Full Sidebar">
        <i class="ri-checkbox-blank-circle-line align-middle"></i>
    </div>

    <!-- Full Sidebar Menu Close Button -->
    <div class="button-close-fullsidebar">
        <i class="ri-close-fill align-middle"></i>
    </div>

    <!-- Sidebar -left -->
    <div class="h-100" id="leftside-menu-container" data-simplebar>
        <ul class="side-nav">
            <li class="side-nav-title">Menus</li>

            <li class="side-nav-item" v-for="(menu, idx) in menuList" :key="`menu_${idx}`" :class="{'menuitem-active' : menu.isActive}">
                <template v-if="menu.subMenus.length > 0">
                    <a data-bs-toggle="collapse show" :href="`#${menu.path}`" aria-expanded="true" :aria-controls="menu.path" class="side-nav-link" @click.prevent="navigateToFirstSubMenu(menu.subMenus[0].path)">
                        <i :class="menu.icon" class="font-22"></i>
                        <span> {{ menu.title }} </span>
                        <span class="menu-arrow"></span>
                    </a>
                    <div class="collapse show" :id="menu.path">
                        <ul class="side-nav-second-level">
                            <li v-for="(subMenu, subIdx) in menu.subMenus" :key="`subMenu_${subIdx}`" :class="{'menuitem-active' : subMenu.isActive}">
                                <router-link :to="subMenu.path">
                                    {{ subMenu.title }}
                                </router-link>
                            </li>
                        </ul>
                    </div>
                </template>

                <router-link :to="menu.path" class="side-nav-link" v-else>
                    <i :class="menu.icon" class="font-22"></i>
                    <span> {{ menu.title }} </span>
                </router-link>
            </li>

            <div class="help-box text-white text-center">
                <!-- <a href="javascript: void(0);" class="float-end close-btn text-white">
                    <i class="mdi mdi-close"></i>
                </a> -->
                <img src="assets/images/svg/help-icon.svg" height="90" alt="Helper Icon Image" />
                <h5 class="mt-3">고시락 광고 상품</h5>
                <p class="mb-3">고시락 광고 상품을 구매하고, 많은 혜택을 누려보세요 : )</p>
                <router-link to="/product" class="btn btn-secondary btn-sm">
                    광고 상품 소개
                </router-link>
            </div>
        </ul>
    </div>
</div>
</template>

<script>
export default {
    data() {
        return {
            menuList: [{
                    title: "고시원 운영",
                    path: "branchManage",
                    isActive: true,
                    icon: "mdi mdi-home-outline",
                    subMenus: [{
                            title: "고시원 관리",
                            path: "/kosiwon/list",
                            isActive: true
                        },
                        {
                            title: "방 관리",
                            path: "/room/list",
                            isActive: false
                        },
                        {
                            title: "입실자 현황",
                            path: "/guest/status",
                            isActive: false
                        },
                        {
                            title: "모든 입실자 보기",
                            path: "/guest/list",
                            isActive: false
                        },
                    ]
                },
                {
                    title: "공지사항",
                    path: "/notice/list",
                    isActive: false,
                    icon: "mdi mdi-bullhorn-variant-outline",
                    subMenus: []
                },
                {
                    title: "알림 내역",
                    path: "/notification",
                    isActive: false,
                    icon: "mdi mdi-bell-ring-outline",
                    subMenus: []
                },
                {
                    title: "자주 묻는 질문",
                    path: "/faq",
                    isActive: false,
                    icon: "mdi mdi-comment-question-outline",
                    subMenus: []
                },
                {
                    title: "광고 상품",
                    path: "/product",
                    isActive: false,
                    icon: "mdi mdi-advertisements",
                    subMenus: []
                },
                {
                    title: "마이 페이지",
                    path: "/mypage",
                    isActive: false,
                    icon: "mdi mdi-account-circle-outline",
                    subMenus: []
                }
            ]
        };
    },
    watch: {
        $route(to, from) {
            this.currentPageAcive(to.path);
            this.$store.commit("CLOSE_SIDE_BAR");
        },
    },
    mounted() {
        this.currentPageAcive(this.$route.path);
    },
    methods: {
        currentPageAcive(currentPath) {
            this.menuList.forEach(menu => {
                // 서브 메뉴가 있을 경우
                if (menu.subMenus.length > 0) {
                    // * some() 반복 중 하나라도 True이면 즉시 반복문을 중지하고 빠져나옴
                    // * 서브 메뉴 path 중 하나라도 현재 path에 속한다면 상위 메뉴 활성화
                    menu.isActive = menu.subMenus.some(subMenu => subMenu.path.includes(currentPath));

                    // * 서브 메뉴 path active 설정
                    menu.subMenus.forEach(subMenu => {
                        subMenu.isActive = subMenu.path.includes(currentPath);
                    });
                } else { // 단일 메뉴일 경우
                    menu.isActive = menu.path.includes(currentPath);
                }
            });
        },
        navigateToFirstSubMenu(path) {
            if (this.$route.path !== path) {
                this.$router.push(path);
            }
        }
    }
};
</script>
